import moment from "moment";
// for dOB to age
const dateDifferenceUsingMoment = (date1, date2) => {
    const m1 = moment(date1);
    const m2 = moment(date2);
  
    const diff = moment.duration(m2.diff(m1));
  
    const years = diff.years();
    const months = diff.months();
    const days = diff.days();
  
    return `${years == 0 ? '' : `${years}y`}  ${months == 0 ? '' : `${months}m`} ${days}d`;
  }
export default dateDifferenceUsingMoment;